import { useState } from "react";
import { Flex, Heading, Button, Text } from "@chakra-ui/react";
import PracticeBiddingGame from "../../components/Practice/PracticeBiddingGame";

const PracticeBidding = () => {
  // null = mode-select screen; "teams" | "cutthroat" = an active simulation.
  const [mode, setMode] = useState(null);
  // Bumped on every "Play Again" so PracticeBiddingGame fully remounts with
  // a fresh random dealer and hands, rather than trying to reset its own
  // internal state in place.
  const [gameKey, setGameKey] = useState(0);

  const startMode = (nextMode) => {
    setGameKey((k) => k + 1);
    setMode(nextMode);
  };

  if (!mode) {
    return (
      <Flex direction="column" align="center" gap="24px" p={{ base: 4, md: 8 }}>
        <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
          Practice Bidding (BETA - ALGO NEEDS TWEAKING)
        </Heading>
        <Text color="gray.600" textAlign="center" maxW="500px">
          Simulate the bidding phase of a real hand with bots filling the other
          seats. There's no card play - the round ends once bidding is resolved
          and you get feedback on your decision.
        </Text>
        <Flex gap="20px" wrap="wrap" justify="center">
          <Button
            onClick={() => startMode("teams")}
            bg="headline.400"
            color="white"
            _hover={{ bg: "#4a919c" }}
          >
            2v2 Teams
          </Button>
          <Button
            onClick={() => startMode("cutthroat")}
            bg="headline.400"
            color="white"
            _hover={{ bg: "#4a919c" }}
          >
            Cutthroat
          </Button>
        </Flex>
      </Flex>
    );
  }

  return (
    <PracticeBiddingGame
      key={gameKey}
      mode={mode}
      onPlayAgain={() => setGameKey((k) => k + 1)}
      onExit={() => setMode(null)}
    />
  );
};
export default PracticeBidding;
